

























































import {
  defineComponent, onMounted, PropType, useFetch
} from '@nuxtjs/composition-api';
import {
  SfCarousel, SfImage, SfButton,
} from '@storefront-ui/vue';
import {usePopularCategories} from '~/modules/gomage/plugin-popular-categories/composables/usePopularCategories';
import { useConfig } from '~/composables';
import {ContentConfigsInterface} from "~/modules/gomage/plugin-page-builder/types";

export default defineComponent({
  name: 'PopularCategories',
  components: {
    SfCarousel,
    SfImage,
    SfButton
  },
  props: {
    data: {
      type: Object as PropType<ContentConfigsInterface>,
    }
  },
  setup(props) {
    let dynamicStyles = null;
    let cssClasses = [];
    const data:ContentConfigsInterface = props.data;
    if(data) {
      dynamicStyles = {
        border: data.border,
        borderColor: data.borderColor,
        borderWidth: data.borderWidth,
        borderRadius: data.borderRadius,
        marginLeft: data.marginLeft,
        marginBottom: data.marginBottom,
        marginRight: data.marginRight,
        marginTop: data.marginTop,
        paddingBottom: data.paddingBottom,
        paddingLeft: data.paddingLeft,
        paddingRight: data.paddingRight,
        paddingTop: data.paddingTop,
        textAlign: data.textAlign
      };
      cssClasses = data.cssClasses;
    }

    const { config } = useConfig();
    const {loadCategories, categories, loading} = usePopularCategories();

    const { fetch } = useFetch(async () => {
      await loadCategories();
    });

    onMounted(async () => {
      fetch()
    });

    return {
      categories,
      cssClasses,
      dynamicStyles,
      loading,
      magentoBaseUrl: config.value.base_url?.replace(/\/+$/, ''),
      categoryUrlSuffix: config.value.category_url_suffix
    };
  },
});
